import { z } from "zod";

export const createCaseSchema = z.object({
    caseUUID: z.string(),
    caseID: z.string(),
});
